module.exports = __webpack_public_path__ + "img/white_mpb_logo.a7f7a6c4.svg";